// Seasonal theme helper
// Returns { emoji, accentClass, label } based on current month
const MONTH_THEMES = {
  0: { emoji: "❄️", accent: "from-blue-50 to-slate-50", label: "winter" },
  1: { emoji: "💛", accent: "from-pink-50 to-amber-50", label: "valentine" },
  2: { emoji: "🍀", accent: "from-green-50 to-emerald-50", label: "spring" },
  3: { emoji: "🌷", accent: "from-pink-50 to-green-50", label: "april" },
  4: { emoji: "🌼", accent: "from-amber-50 to-yellow-50", label: "may" },
  5: { emoji: "☀️", accent: "from-yellow-50 to-orange-50", label: "summer" },
  6: { emoji: "🎆", accent: "from-red-50 to-blue-50", label: "july" },
  7: { emoji: "🌞", accent: "from-amber-50 to-orange-50", label: "summer" },
  8: { emoji: "🍂", accent: "from-orange-50 to-amber-50", label: "fall" },
  9: { emoji: "🎃", accent: "from-orange-100 to-amber-100", label: "halloween" },
  10: { emoji: "🦃", accent: "from-amber-50 to-orange-50", label: "thanksgiving" },
  11: { emoji: "🎄", accent: "from-red-50 to-green-50", label: "holiday" },
};

export function currentTheme() {
  const m = new Date().getMonth();
  return MONTH_THEMES[m] || { emoji: "✨", accent: "from-green-50 to-emerald-50", label: "default" };
}
